module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_6005.827b26f1.png";